module.exports = __webpack_public_path__ + "img/TailWing-Repairing_II.5111428d.jpg";